export const PROJECT_SCOPE_HEADER = 'X-Project-Id';

// Mutable holder for the active project-scope id, kept in sync from the redux
// store. Breaks a store<->axios import cycle (see store.ts subscribe).
let projectScopeId: number | null = null;

export function setProjectScopeId(id: number | null): void {
  projectScopeId = id;
}

export function getProjectScopeId(): number | null {
  return projectScopeId;
}
